import ApplicationFees from "./ApplicationFees";

export default ApplicationFees;
